import axios from "axios";
import axiosInstance from "./axiosInstance";

class TipoLegislacaoApi {
  cancelTokens = {
    getTiposLegislacao: null,
  };

  isCancel(exceptionThrown) {
    return axios.isCancel(exceptionThrown);
  }

  async getTiposLegislacao(enteFederativoId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getTiposLegislacao = source;

    const params = {};
    if (enteFederativoId) {
      params.ente_federativo_id = enteFederativoId;
    }

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/tipos_legislacoes`,
      {
        params,
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getTiposLegislacao = null;

    return data;
  }
}

export default TipoLegislacaoApi;
